export default __webpack_public_path__ + "static/media/icon_location_red.2dc223ee.svg";